module.exports = __webpack_public_path__ + "prod/20261104151832/img/service.f8729c23.png";